document.addEventListener('DOMContentLoaded', function () {
    /* Product Section */
    const productSection = document.querySelector(".product-section");

    const productMainImage = productSection.querySelector(".main-image");
    const productGalleryRows = productSection.querySelectorAll(".gallery-row img");

    for (let i = 0; i < productGalleryRows.length; i++) {
        productGalleryRows[i].addEventListener("click", function() {
            productSection.querySelector(".gallery-row img.active").classList.remove("active");
            this.classList.add("active");

            let gallerySrc = this.getAttribute("src");
            productMainImage.setAttribute("src", gallerySrc);
        });
    }

    const faqRowTops = productSection.querySelectorAll(".faq-row .top");
    for (let i = 0; i < faqRowTops.length; i++) {
        faqRowTops[i].addEventListener("click", function() {
            const faqRow = this.parentElement;
            const faqRowBottom = faqRow.querySelector(".bottom");
            
            if (faqRow.classList.contains("active")) {
                faqRow.classList.remove("active");
                faqRowBottom.style.height = "0";
            }
            else {
                faqRow.classList.add("active");
                const text = faqRowBottom.querySelector(".text");
                const height = text.offsetHeight + 15;
                faqRowBottom.style.height = `${height}px`;
            }
        });
    }

    const quantityNumber = document.querySelector(".quantity-number");
    const quantityButtons = document.querySelectorAll(".quantity-button");

    for (let i = 0; i < quantityButtons.length; i++) {
        quantityButtons[i].addEventListener("click", function() {
            let value = parseInt(quantityNumber.innerHTML);

            if (this.classList.contains("minus")) {
                value--;
                if (value < 1) {
                    value = 1;
                }
                quantityNumber.innerHTML = value;
            }
            else {
                value++;
                quantityNumber.innerHTML = value;
            }
        });
    }

    /* Detailed Benefits Section */
    const detailedBenefitsSection = document.querySelector(".detailed-benefits-section");
    const detailedRowTops = detailedBenefitsSection.querySelectorAll(".top");

    for (let i = 0; i < detailedRowTops.length; i++) {
        detailedRowTops[i].addEventListener("click", function() {
            const detailedRow = this.parentElement;
            const detailedRowBottom = detailedRow.querySelector(".bottom");
            const detailedRowBottomText = detailedRowBottom.querySelector(".text");
            const expandCollapse = this.querySelector(".expand-collapse");

            if (detailedRow.classList.contains("active")) {
                detailedRow.classList.remove("active");
                detailedRowBottom.style.height = "0";
                expandCollapse.setAttribute("src", "https://cdn.shopify.com/s/files/1/0756/0599/9854/files/plus_1.png?v=1750092862");
            }
            else {
                detailedRow.classList.add("active");
                const height = detailedRowBottomText.offsetHeight + 12;
                detailedRowBottom.style.height = `${height}px`;
                expandCollapse.setAttribute("src", "https://cdn.shopify.com/s/files/1/0756/0599/9854/files/minus_2.png?v=1750093545");
            }
        });
    }
    /* End Detailed Benefits Section */

    /* Ingredients Modal */
    let ingredientsModal = document.querySelector(".ingredients-modal");
    let detailedHeadings = document.querySelectorAll(".detailed-benefit-heading");
    let nutritionFactsButton = document.querySelector("#nutrition-facts-button");

    // Add target event to Happy Fruit Cannabis menu link so it opens in new tab
    const happyFruitCannabisLink = document.querySelector("#HeaderMenu-happy-fruit-cannabis");
    if (happyFruitCannabisLink) {
        happyFruitCannabisLink.setAttribute("target", "_blank");
    }

    // Close ingredients modal if escape is pressed
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
        ingredientsModal.classList.remove("active");
        ingredientsModal.style.opacity = "0";
        }
    });

    // Open ingredients modal when ingredients button is clicked
    nutritionFactsButton.addEventListener("click", function() {
        ingredientsModal.style.opacity = "unset";
        ingredientsModal.classList.add("active");
    });

    // Close ingredients modal if background is clicked
    let ingredientsModalBackground = ingredientsModal.querySelector(".background");
    ingredientsModalBackground.addEventListener("click", function() {
        ingredientsModal.classList.remove("active");
        ingredientsModal.style.opacity = "0";
    });
    /* End Ingredients Modal */

    /* Experience Section */
    const experienceSection = document.querySelector(".experience-section");

    const carouselContainer = experienceSection.querySelector(".carousel-container");
    const carouselColumns = carouselContainer.querySelectorAll(".column");
    const carouselMainColumns = carouselContainer.querySelectorAll(".main-column");

    const leftArrow = experienceSection.querySelector(".left-arrow");
    const rightArrow = experienceSection.querySelector(".right-arrow");

    const carouselDots = experienceSection.querySelectorAll('.dot');

    let carouselIndex = 0;
    carouselDots[0].classList.add("active");

    scrollAmount = carouselContainer.scrollWidth / carouselColumns.length;
    carouselContainer.scrollLeft += scrollAmount * 2;

    leftArrow.addEventListener("click", function() {
        scrollAmount = carouselContainer.scrollWidth / carouselColumns.length;
        carouselContainer.scrollLeft -= scrollAmount;

        experienceSection.querySelector('.dot.active').classList.remove("active");

        if (carouselIndex <= 0) {
            leftArrow.style.pointerEvents = "none";
            rightArrow.style.pointerEvents = "none";
            setTimeout(() => {
                carouselContainer.style.scrollBehavior = 'auto'; 
                carouselContainer.scrollLeft = scrollAmount * (carouselColumns.length - 6);
                carouselContainer.style.scrollBehavior = 'smooth'; 
                leftArrow.style.pointerEvents = "unset";
                rightArrow.style.pointerEvents = "unset";

                carouselIndex = carouselMainColumns.length - 1;
                carouselDots[carouselIndex].classList.add("active");
            }, 400);
        }
        else {
            carouselIndex--;
            carouselDots[carouselIndex].classList.add("active");
        }
    });
    rightArrow.addEventListener("click", function() {
        scrollAmount = carouselContainer.scrollWidth / carouselColumns.length;
        carouselContainer.scrollLeft += scrollAmount;

        experienceSection.querySelector('.dot.active').classList.remove("active");

        if (carouselIndex >= carouselMainColumns.length - 1) {
            leftArrow.style.pointerEvents = "none";
            rightArrow.style.pointerEvents = "none";
            setTimeout(() => {
                carouselContainer.style.scrollBehavior = 'auto'; 
                carouselContainer.scrollLeft = scrollAmount * 2;
                carouselContainer.style.scrollBehavior = 'smooth'; 
                rightArrow.style.pointerEvents = "unset";
                leftArrow.style.pointerEvents = "unset";

                carouselIndex = 0;
                carouselDots[carouselIndex].classList.add("active");
            }, 400);
        }
        else {
            carouselIndex++;
            carouselDots[carouselIndex].classList.add("active");
        }
    });

    // Dots handler
    for (let i = 0; i < carouselDots.length; i++) {
        carouselDots[i].addEventListener("click", function() {
            experienceSection.querySelector('.dot.active').classList.remove("active");
            this.classList.add("active");

            scrollAmount = carouselContainer.scrollWidth / carouselColumns.length;
            carouselContainer.scrollLeft = scrollAmount * (i + 2);
        });
    }

    /* End Experience Section */
});